export default __webpack_public_path__ + "static/media/disc_4.1656b9e9.png";